import React, { useState, useEffect } from "react";
import { Box, IconButton } from "@mui/material";
import "./excelOutput.scss";
import Buttons from "../../../components/Controls/Buttons/Button";
import { useDispatch, useSelector } from "react-redux";
import * as acts from "../../../redux/administrator/actions";
import ModalProcessor from "../../../components/Modal/RejectModal/ModalProcessor";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import Progressbar from "../../../components/ProgressBar";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
// import "./pdf-layer-fix.css";

import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import XlsxCsvViewer from "./xlsxViewer";

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.mjs',
//   import.meta.url,
// ).toString();
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const Index = ({ dialogData, handleDialogClose, isViewOnly }) => {
  const data = dialogData;
  const [isOpen, setIsOpen] = useState(false);
  const [isLoader, setIsLoader] = useState();

  const Dispatch = useDispatch();

  const outPutUrl = useSelector((state) => state?.admin?.outPutUrl);
  const outPutUpload = useSelector((state) => state?.admin.outPutUpload);
  const rejectOutPutBatch = useSelector(
    (state) => state?.admin?.rejectOutPutBatch
  );
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const [apiStatus, setApiStatus] = useState({
    isError: false,
    isSuccess: false,
    message: "",
  });

  useEffect(() => {
    if (outPutUpload?.apiSuccess) {
      apiStatus.isSuccess = true;
      apiStatus.message = "Submitted Successfully";
      setApiStatus({ ...apiStatus });
      setTimeout(() => {
        Dispatch(acts.clearSubmitOutputUpload());
        handleDialogClose();
      }, 2000);
    } else if (outPutUpload?.apiError) {
      apiStatus.isError = true;
      apiStatus.message = outPutUpload.message;
      setApiStatus({ ...apiStatus });
      setTimeout(() => {
        Dispatch(acts.clearSubmitOutputUpload());
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outPutUpload]);

  useEffect(() => {
    if (rejectOutPutBatch?.apiSuccess) {
      setIsOpen(false);
      apiStatus.isSuccess = true;
      apiStatus.message = "Rejected Successfully";
      setApiStatus({ ...apiStatus });
      setTimeout(() => {
        Dispatch(acts.clearRejectoutputFileBatch());
        handleDialogClose();
      }, 2000);
    } else if (rejectOutPutBatch?.apiError) {
      setIsOpen(false);
      apiStatus.isError = true;
      apiStatus.message = rejectOutPutBatch.message;
      setApiStatus({ ...apiStatus });
      setTimeout(() => {
        Dispatch(acts.clearRejectoutputFileBatch());
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rejectOutPutBatch]);

  const handleReject = () => {
    setIsOpen(true);
  };

  const handleSubmit = (id) => {
    Dispatch(acts.submitOutputUpload(id));
  };
  useEffect(() => {
    setIsLoader(true);
    Dispatch(acts.getOutPutUrl(data?.id));

    setTimeout(() => {
      setIsLoader(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outPutUrl?.filePath]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleApiStatus = () => {
    setApiStatus({
      isError: false,
      isSuccess: false,
      message: "",
    });
  };

  const clickToReject = (comment) => {
    let data = {
      batch_id: outPutUrl?.batch_id,
      projectId: outPutUrl?.projectId,
      rejection_remark: comment,
      id: dialogData.id,
    };
    Dispatch(acts.rejectoutputFileBatch(data));
  };

  return (
    <>
      <Box className="PdfOutput-wrap">
        {isOpen && (
          <ModalProcessor
            modalOpen={isOpen}
            handleClose={() => setIsOpen(false)}
            handleReject={(comment) => clickToReject(comment)}
          />
        )}
        <Box className="PdfOutput-container">
          <p>{data?.project_name + " / " + data?.batch_name}</p>
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      <Box className={isViewOnly ? "xlsx-wrap-fullheight" : "xlsx-wrap"}>
        {isLoader ? (
          <Progressbar />
        ) : (
          <>
            {outPutUrl?.file_type === "xlsx" ||
            outPutUrl?.file_type === "csv" ? (
              <div className="xlsx-fileViewer">
                <XlsxCsvViewer filePath={outPutUrl?.file_path} />
                {/* ********************************
                <FileViewer
                  fileType={outPutUrl?.file_type}
                  filePath={outPutUrl?.file_path}
                  errorComponent={"error"}
                /> */}
              </div>
            ) : (
              <div>
                <Box className="pagination">
                  <div className="p-sticky">
                    <label className="paginationLabel">Page {pageNumber}</label>
                    <IconButton
                      aria-label="left"
                      onClick={() =>
                        pageNumber === 1 ? "" : setPageNumber(pageNumber - 1)
                      }
                      disabled={pageNumber === 1}
                    >
                      <ChevronLeftIcon />
                    </IconButton>
                    <IconButton
                      aria-label="right"
                      onClick={() => setPageNumber(pageNumber + 1)}
                      disabled={pageNumber === numPages}
                    >
                      <ChevronRightIcon />
                    </IconButton>
                  </div>
                </Box>

                {/* <div>
                  <Document
                    file={outPutUrl?.file_path}
                    onLoadSuccess={({ numPages }) =>
                      console.log(`Loaded ${numPages} pages`)
                    }
                    onLoadError={(error) =>
                      console.error("Error while loading PDF: ", error)
                    }
                  >
                    <Page pageNumber={pageNumber} />
                  </Document>
                </div> */}

                <div
                // className="doc-pdf-container"
                >
                  <Box
                    //  className="doc-pdf"
                    style={{ padding: "35px 0px" }}
                  >
                    <Document
                      file={outPutUrl?.file_path}
                      onLoadSuccess={onDocumentLoadSuccess}
                      renderMode="canvas"
                      className="custom-pdf-document"
                    >
                      <Page pageNumber={pageNumber} />
                    </Document>
                  </Box>
                </div>
              </div>
            )}
          </>
        )}
      </Box>

      {!isViewOnly && (
        <Box className="bottom-div-excel-op">
          <Buttons
            className="admin-reject-btn"
            variant="contained"
            size="small"
            text="Reject"
            type="submit"
            onClick={() => handleReject()}
          />
          <Buttons
            className="admin-submit-btn"
            variant="contained"
            size="small"
            text="Approve"
            type="submit"
            onClick={() => handleSubmit(data?.id)}
          />
        </Box>
      )}

      {(apiStatus?.isError || apiStatus?.isSuccess) && (
        <CustomizedSnackbars
          severity={apiStatus?.isError ? "error" : "success"}
          state={apiStatus?.isError || apiStatus?.isSuccess}
          text={apiStatus?.message}
          handleClose={() => handleApiStatus()}
        />
      )}
    </>
  );
};

export default Index;
